"use client";

import { useTheme } from "@/components/utils/ThemeProvider";
import MoonIcon from "@/components/icons/Moon.icon";
import SunIcon from "@/components/icons/Sun.icon";

export default function ThemeToggle({
  currentLang = "de"
}: {
  currentLang: "en" | "de"
}) {

  const { theme, toggleTheme } = useTheme();

  const ariaLabels = {
    en: {
      light: "Switch to dark mode",
      dark: "Switch to light mode",
    },
    de: {
      light: "Auf dunklen Modus umschalten",
      dark: "Auf hellen Modus umschalten",
    },
  };

  const currentThemeState = theme === "dark" ? "dark" : "light";
  const currentLabel = ariaLabels[currentLang][currentThemeState];

  return (
    <button
      onClick={toggleTheme}
      className="p-2 group rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green"
      aria-label={currentLabel}
    >
      {theme === "light" ? (
        // light mode (switch to dark)
        <MoonIcon className="text-black dark:text-white group-hover:scale-120 group-hover:text-blue-300 duration-300" />
      ) : (
        // dark mode (switch to light)
        <SunIcon className="text-white dark:text-white group-hover:scale-120 group-hover:text-orange-300 duration-300" />
      )}
    </button>
  );
}